import script from "./BidViewLawFirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./BidViewLawFirm.vue?vue&type=script&setup=true&lang=ts"

import "./BidViewLawFirm.vue?vue&type=style&index=0&id=a0fa8f94&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0fa8f94"]])

export default __exports__